import { FeedbackStatusProps } from '../../../types/feedbackDetailTypes';
import { RecommendationStatus } from './RecommendationStatus';
import { ScorecardProgressStatus, TotalScoreStatus } from '../Statuses';

export const FeedbackStatus: React.FC<FeedbackStatusProps> = ({
  cumulativeScore,
  maxCumulativeScore,
  finalRecommendation,
  showTotalOnPreview,
  hasRecommendation,
  hasScore,
  completionText,
}) => {
  if (!hasRecommendation && hasScore) {
    return (
      <TotalScoreStatus
        completionText={completionText}
        cumulativeScore={cumulativeScore}
        maxCumulativeScore={maxCumulativeScore}
      />
    );
  }

  if (!hasRecommendation && !hasScore) {
    return <ScorecardProgressStatus completionText={completionText} />;
  }

  if (hasRecommendation) {
    return (
      <RecommendationStatus
        cumulativeScore={cumulativeScore}
        finalRecommendation={finalRecommendation}
        maxCumulativeScore={maxCumulativeScore}
        showTotalOnPreview={showTotalOnPreview}
        completionText={completionText}
      />
    );
  }

  return <></>;
};
